import { VueQueryPlugin } from '@tanstack/vue-query'
import { initializeLogger } from '@thyme/libs/src/logging/logger'
import { MEILI_SEARCH_CONFIG_KEY } from '@thyme/libs/src/meiliSearch/config'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import App from '@/App.vue'

import '@/scss/app.scss'

import { auth0 } from '@/libs/state/auth0Client'
import { loadAppConfig } from './libs/config/config'
import { APP_CONFIG_KEY } from './libs/config/types'

import { initializeDatadog } from './libs/datadog/datadog'
import NashvilleConnectTheme from './nashville/theme'
import { router } from './router'

const app = createApp(App)

// Top-level await is not allowed in older browsers.
loadAppConfig()
  .then((config) => {
    app.provide(APP_CONFIG_KEY, config)
    app.provide(MEILI_SEARCH_CONFIG_KEY, config.meiliSearch)
    initializeLogger(config)
    initializeDatadog(config)

    app.use(auth0(config))
    app.use(VueQueryPlugin, {
      enableDevtoolsV6Plugin: true,
    })
    app.use(router)
    app.use(createPinia())
    app.use(PrimeVue, {
      theme: {
        preset: NashvilleConnectTheme,
        options: {
          darkModeSelector: false,
        },
      },
    })

    // No-op directive to avoid errors from components expecting it
    app.directive('tooltip', {})

    app.mount('#app')

    return app
  })
  // eslint-disable-next-line unicorn/prefer-top-level-await
  .catch(console.error)
